import React from 'react';
import SVGIcon from '../components/SVGIcon';
import { gql } from '../graphql/generated';
import type { DocumentType } from '../graphql/generated';
import allTopicsIcon from '../icons/non-prefilled/16x16/allTopics.svg';
import favoriteIcon from '../icons/non-prefilled/16x16/favorite.svg';
import aiChipSparkIcon from '../icons/non-prefilled/sidebar/aiChipSpark.svg';
import analyticsPieIcon from '../icons/non-prefilled/sidebar/analyticsPie.svg';
import astronomyPlanetRingStarIcon from '../icons/non-prefilled/sidebar/astronomyPlanetRingStar.svg';
import bacteriaIcon from '../icons/non-prefilled/sidebar/bacteria.svg';
import baggageIcon from '../icons/non-prefilled/sidebar/baggage.svg';
import basketballBallIcon from '../icons/non-prefilled/sidebar/basketballBall.svg';
import beachPalmIcon from '../icons/non-prefilled/sidebar/beachPalm.svg';
import bookCloseIcon from '../icons/non-prefilled/sidebar/bookClose.svg';
import bulbIcon from '../icons/non-prefilled/sidebar/bulb.svg';
import businessClimbTopIcon from '../icons/non-prefilled/sidebar/businessClimbTop.svg';
import champagneCheersIcon from '../icons/non-prefilled/sidebar/champagneCheers.svg';
import checklistIcon from '../icons/non-prefilled/sidebar/checklist.svg';
import chessFiguresIcon from '../icons/non-prefilled/sidebar/chessFigures.svg';
import cloudIcon from '../icons/non-prefilled/sidebar/cloud.svg';
import coffeeCupIcon from '../icons/non-prefilled/sidebar/coffeeCup.svg';
import colorPaintingPaletteIcon from '../icons/non-prefilled/sidebar/colorPaintingPalette.svg';
import computerBugIcon from '../icons/non-prefilled/sidebar/computerBug.svg';
import conversationChatIcon from '../icons/non-prefilled/sidebar/conversationChat.svg';
import databaseIcon from '../icons/non-prefilled/sidebar/database.svg';
import deliveryTruckIcon from '../icons/non-prefilled/sidebar/deliveryTruck.svg';
import diamondIcon from '../icons/non-prefilled/sidebar/diamond.svg';
import eSportKingIcon from '../icons/non-prefilled/sidebar/eSportKing.svg';
import earthModelIcon from '../icons/non-prefilled/sidebar/earthModel.svg';
import electionIcon from '../icons/non-prefilled/sidebar/election.svg';
import fantasyUnicornIcon from '../icons/non-prefilled/sidebar/fantasyUnicorn.svg';
import fitnessWeightsIcon from '../icons/non-prefilled/sidebar/fitnessWeights.svg';
import folderBookmarkIcon from '../icons/non-prefilled/sidebar/folderBookmark.svg';
import gaugeDashboardIcon from '../icons/non-prefilled/sidebar/gaugeDashboard.svg';
import golfHoleIcon from '../icons/non-prefilled/sidebar/golfHole.svg';
import graduationHatIcon from '../icons/non-prefilled/sidebar/graduationHat.svg';
import hammerWrenchIcon from '../icons/non-prefilled/sidebar/hammerWrench.svg';
import hierarchyIcon from '../icons/non-prefilled/sidebar/hierarchy.svg';
import historicalBuildingTowerIcon from '../icons/non-prefilled/sidebar/historicalBuildingTower.svg';
import labFlaskExperimentIcon from '../icons/non-prefilled/sidebar/labFlaskExperiment.svg';
import legalHammerIcon from '../icons/non-prefilled/sidebar/legalHammer.svg';
import loveItIcon from '../icons/non-prefilled/sidebar/loveIt.svg';
import mapsIcon from '../icons/non-prefilled/sidebar/maps.svg';
import performanceIncreaseIcon from '../icons/non-prefilled/sidebar/performanceIncrease.svg';
import programmingBrowserIcon from '../icons/non-prefilled/sidebar/programmingBrowser.svg';
import quillIcon from '../icons/non-prefilled/sidebar/quill.svg';
import rankingWinnerMedalIcon from '../icons/non-prefilled/sidebar/rankingWinnerMedal.svg';
import sailingBoatIcon from '../icons/non-prefilled/sidebar/sailingBoat.svg';
import satelliteIcon from '../icons/non-prefilled/sidebar/satellite.svg';
import savingPiggyDollarsIcon from '../icons/non-prefilled/sidebar/savingPiggyDollars.svg';
import serverIcon from '../icons/non-prefilled/sidebar/server.svg';
import servingDomeIcon from '../icons/non-prefilled/sidebar/servingDome.svg';
import shipmentCraneIcon from '../icons/non-prefilled/sidebar/shipmentCrane.svg';
import shopIcon from '../icons/non-prefilled/sidebar/shop.svg';
import spaceRocketFlyingIcon from '../icons/non-prefilled/sidebar/spaceRocketFlying.svg';
import sparkleIcon from '../icons/non-prefilled/sidebar/sparkle.svg';
import tagsIcon from '../icons/non-prefilled/sidebar/tags.svg';
import technologyRobotHeadIcon from '../icons/non-prefilled/sidebar/technologyRobotHead.svg';
import videoGameSwordIcon from '../icons/non-prefilled/sidebar/videoGameSword.svg';
import vintageTvIcon from '../icons/non-prefilled/sidebar/vintageTv.svg';
import vipCrownQueenIcon from '../icons/non-prefilled/sidebar/vipCrownQueen.svg';
import appIcon from '../icons/prefilled/16x16/app.svg';
import * as styles from './SidebarSectionIcon.module.scss';
import { PremadeSections } from './SidebarSectionsProvider';

export const DEFAULT_SIDEBAR_ICON = { name: 'favorite', icon: favoriteIcon };

export const SIDEBAR_ICONS = [
  // Simple action
  DEFAULT_SIDEBAR_ICON,
  { name: 'loveIt', icon: loveItIcon },
  { name: 'tags', icon: tagsIcon },
  { name: 'checklist', icon: checklistIcon },
  { name: 'folderBookmark', icon: folderBookmarkIcon },
  { name: 'bookClose', icon: bookCloseIcon },
  { name: 'conversationChat', icon: conversationChatIcon },
  { name: 'sparkle', icon: sparkleIcon },
  { name: 'bulb', icon: bulbIcon },
  { name: 'quill', icon: quillIcon },

  // Activities
  { name: 'flag', icon: golfHoleIcon },
  { name: 'fitnessWeights', icon: fitnessWeightsIcon },
  { name: 'colorPaintingPalette', icon: colorPaintingPaletteIcon },
  { name: 'basketballBall', icon: basketballBallIcon },
  { name: 'chessFigures', icon: chessFiguresIcon },
  { name: 'eSportKing', icon: eSportKingIcon },
  { name: 'vintageTv', icon: vintageTvIcon },
  { name: 'videoGameSword', icon: videoGameSwordIcon },
  { name: 'historicalBuildingTower', icon: historicalBuildingTowerIcon },
  { name: 'diamond', icon: diamondIcon },
  { name: 'vipCrownQueen', icon: vipCrownQueenIcon },
  { name: 'sailingBoat', icon: sailingBoatIcon },
  { name: 'beachPalm', icon: beachPalmIcon },

  // Business & metaphors
  { name: 'baggage', icon: baggageIcon },
  { name: 'coffeeCup', icon: coffeeCupIcon },
  { name: 'champagneCheers', icon: champagneCheersIcon },
  { name: 'gaugeDashboard', icon: gaugeDashboardIcon },
  { name: 'analyticsPie', icon: analyticsPieIcon },
  { name: 'performanceIncrease', icon: performanceIncreaseIcon },
  { name: 'hierarchy', icon: hierarchyIcon },
  { name: 'maps', icon: mapsIcon },
  { name: 'earthModel', icon: earthModelIcon },
  { name: 'graduationHat', icon: graduationHatIcon },
  { name: 'rankingWinnerMedal', icon: rankingWinnerMedalIcon },
  { name: 'businessClimbTop', icon: businessClimbTopIcon },
  { name: 'fantasyUnicorn', icon: fantasyUnicornIcon },
  { name: 'spaceRocketFlying', icon: spaceRocketFlyingIcon },
  { name: 'servingDome', icon: servingDomeIcon },
  { name: 'savingPiggyDollars', icon: savingPiggyDollarsIcon },
  { name: 'legalHammer', icon: legalHammerIcon },
  { name: 'election', icon: electionIcon },
  { name: 'deliveryTruck', icon: deliveryTruckIcon },
  { name: 'shop', icon: shopIcon },

  // Engineering
  { name: 'shipmentCrane', icon: shipmentCraneIcon },
  { name: 'wrench', icon: hammerWrenchIcon },
  { name: 'cloud', icon: cloudIcon },
  { name: 'database', icon: databaseIcon },
  { name: 'server', icon: serverIcon },
  { name: 'languageCode', icon: programmingBrowserIcon },
  { name: 'computerBug', icon: computerBugIcon },

  // Science
  { name: 'labFlaskExperiment', icon: labFlaskExperimentIcon },
  { name: 'aiChipSpark', icon: aiChipSparkIcon },
  { name: 'bacteria', icon: bacteriaIcon },
  { name: 'technologyRobotHead', icon: technologyRobotHeadIcon },
  { name: 'satellite', icon: satelliteIcon },
  { name: 'astronomyPlanetRingStar', icon: astronomyPlanetRingStarIcon },
];
const SIDEBAR_ICONS_MAP = SIDEBAR_ICONS.reduce<Record<string, string>>(
  (acc, { name, icon }) => ({ ...acc, [name]: icon }),
  {},
);

const SIDEBAR_SECTION_ICON_FRAGMENT = gql(`
    fragment SidebarSectionIcon_section on Section {
      id
      icon
      color
    }
  `);

interface SidebarSectionIconContainerProps {
  children: React.ReactNode;
  color: string | null;
}

export const SidebarSectionIconContainer = ({
  children,
  color,
}: SidebarSectionIconContainerProps) => (
  <span
    className={styles.sectionIcon}
    style={color ? { color: `#${color}` } : undefined}
  >
    {children}
  </span>
);

interface SidebarSectionIconProps {
  section: DocumentType<typeof SIDEBAR_SECTION_ICON_FRAGMENT>;
}

const SidebarSectionIcon = ({ section }: SidebarSectionIconProps) => {
  if (section.id === PremadeSections.MY_TOPICS) {
    return <SVGIcon className={styles.myTopicsIcon}>{allTopicsIcon}</SVGIcon>;
  }

  if (section.id === PremadeSections.ALL_TOPICS) {
    return <SVGIcon className={styles.allTopicsIcon}>{allTopicsIcon}</SVGIcon>;
  }

  if (section.id === PremadeSections.INTEGRATIONS) {
    return <SVGIcon>{appIcon}</SVGIcon>;
  }

  return (
    <SidebarSectionIconContainer color={section.color ?? null}>
      <SVGIcon>
        {(section.icon && SIDEBAR_ICONS_MAP[section.icon]) ||
          DEFAULT_SIDEBAR_ICON.icon}
      </SVGIcon>
    </SidebarSectionIconContainer>
  );
};

export default SidebarSectionIcon;
